import { ReactNode, useState } from "react";
import { Accordion } from "components/DesignSystem/Accordion/Accordion";

type SeasonAccordionProps = {
  seasons: number[];

  defaultOpenSeasons: string[];

  renderSeason: (season: number) => ReactNode;
};

export const SeasonAccordion = ({
  seasons,
  defaultOpenSeasons,
  renderSeason,
}: SeasonAccordionProps) => {
  const [openSeasons, setOpenSeasons] = useState(defaultOpenSeasons);

  return (
    <Accordion.Root
      type="multiple"
      value={openSeasons}
      onValueChange={setOpenSeasons}
      className="t-flex t-flex-col t-gap-3"
    >
      {seasons.map((season) => (
        <Accordion.Item key={season} value={String(season)}>
          <Accordion.Trigger>Season {season}</Accordion.Trigger>

          <Accordion.Content className="t-flex t-flex-col t-gap-6">
            {renderSeason(season)}
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
};
